var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-table',{staticClass:"table-striped",attrs:{"items":_vm.viewPricingArray,"fields":_vm.fieldsForPricingItems},scopedSlots:_vm._u([{key:"number",fn:function(data){return [_c('strong',[_vm._v(_vm._s(data.index + 1))])]}},{key:"incomingPriceUzs",fn:function(data){return [_vm._v("\n\t\t\t   "+_vm._s(_vm._f("currency")(data.item.incomingPriceUzs,{
			   symbol:
			   _vm.userDepCurrencyName, fractionCount: 2, symbolPosition: 'back'
			   }))+"\n\t\t   ")]}},{key:"priceUzs",fn:function(data){return [_vm._v("\n\t\t\t   "+_vm._s(_vm._f("currency")(data.item.priceUzs,{
			   symbol:
			   _vm.userDepCurrencyName, fractionCount: 2, symbolPosition: 'back'
			   }))+"\n\t\t   ")]}},{key:"priceWholesale",fn:function(data){return [_vm._v("\n\t\t\t   "+_vm._s(_vm._f("currency")(data.item.priceWholesale,{
			   symbol:
			   _vm.userDepCurrencyName, fractionCount: 2, symbolPosition: 'back'
			   }))+"\n\t\t   ")]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }